import { render, staticRenderFns } from "./LmPrivileges.vue?vue&type=template&id=44195382"
import script from "./LmPrivileges.vue?vue&type=script&lang=js"
export * from "./LmPrivileges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports